import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import { getOrders } from '../../actions/Orders';
import CONSTANTS from '../../constants';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import LoginService from '../../services/LoginService';

// TODO: Update new comments in db
const ORDER_STATUS_COMMENT = {
  10: 'You have multiple orders',
  11: 'Your order has been placed',
  12: 'Your order has been seen',
  13: 'Your order is being prepared',
  14: 'Your order has been served',
  15: 'Thank you for ordering from us',
  19: 'Your order is cancelled',
  20: 'Your bill has been requested',
  21: 'Your order is ready to pickup',
  22: 'Your order is on its way'
};

// TODO: Update new colors in db
const COLOR_STATUS = {
  10: '#8c4fae',
  11: '#ff5b5b',
  12: '#ffab2f',
  13: '#f0e60a',
  14: '#00ccff',
  15: '#00cdbe',
  19: '#a6a6a6',
  20: '#00eee7'
};

class StatusBlock extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
    this.timeoutId = null;
  }

  componentDidMount() {
    this.getOrders();
  }

  componentDidUpdate() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(
      this.getOrders.bind(this),
      CONSTANTS.SETTINGS.STATUS_POLLING_INTERVAL
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  getOrders() {
    const locationIds = this.props.outlets;
    if (LoginService.getToken()) this.props.getOrders(LoginService.getToken().userId, locationIds);
  }

  firebaseEvent(firebaseEventName) {
    AnalyticsService.logEvent(firebaseEventName, {
      locationId: this.props._location ? this.props._location.slug : null,
      category: CONSTANTS.EVENTS.MENU.GROUP_NAME
    });
  }

  toggleModal() {
    this.setState({ visible: !this.state.visible });
  }

  renderMultipleLocationOrders(locations, orders, settings) {
    return [
      <div
        onClick={this.toggleModal.bind(this)}
        key="link"
        className="order-status-block"
        style={{ backgroundColor: COLOR_STATUS[10] }}
      >
        {`You have ${locations.length} live orders`}
      </div>,
      <Modal
        centered={true}
        key="modal"
        isOpen={this.state.visible}
        toggle={this.toggleModal.bind(this)}
      >
        <ModalBody>
          <div className="row">
            {locations.map((location) => {
              let locationOrders = orders[location];
              return (
                <div key={location} className="col-6">
                  <div
                    className="p-3"
                    style={{ backgroundColor: locationOrders[0].Status.status_color }}
                  >
                    <Link
                      to={`${CONSTANTS.BASE_URL}${locationOrders[0].Location.slug}/orders/status`}
                    >
                      <div className="text-white text-center f2">
                        {locationOrders[0].Location.name}
                      </div>
                      <div className="text-white text-center f2">
                        {ViewHelper.ordersCount(locationOrders)}
                      </div>
                      <div className="text-white text-center f2">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    ];
  }

  renderSingleLocationOrder(locations, orders, settings) {
    let locationOrder = orders[locations[0]][0];
    if (this.props.grid_layout === 'old') {
      return (
        <Link to={`${CONSTANTS.BASE_URL}${locationOrder.Location.slug}/orders/status`}>
          {locationOrder.Status.status_id === 15 && (
            <div
              className="order-status-block"
              style={{ backgroundColor: this.props.locationSettings?.basecolor }}
            >
              {ORDER_STATUS_COMMENT[parseInt(locationOrder.Order.status_id)]}
              <span className="float-right mr-1" style={{ float: 'right', paddingRight: '5px' }}>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </div>
          )}
          {locationOrder.Status.status_id !== 15 && (
            <div
              className="order-status-block"
              style={{ backgroundColor: locationOrder.Status.status_color }}
            >
              {ORDER_STATUS_COMMENT[parseInt(locationOrder.Order.status_id)]}
              <span className="float-right mr-1" style={{ float: 'right', paddingRight: '5px' }}>
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </div>
          )}
        </Link>
      );
    } else if (this.props.grid_layout !== 'old') {
      let cartList = document.getElementsByClassName('cart-list');
      if (cartList.length > 0) {
        cartList[0].classList.add('cart-list-with-status');
      }
      if (!locationOrder?.Status) {
        return '';
      }
      return (
        <StyledUpdatedStatusBlock className={'order-status-section'}>
          <Link to={`${CONSTANTS.BASE_URL}${locationOrder?.Location?.slug}/orders/status`}>
            {locationOrder?.Status?.status_id === 15 && (
              <div
                className="order-status-block"
                style={{ backgroundColor: this.props?.locationSettings?.basecolor }}
              >
                {ORDER_STATUS_COMMENT[parseInt(locationOrder.Order.status_id)]}
                {/*Your order has been placed*/}
                <span className="float-right mr-1">
                  <FontAwesomeIcon icon={faArrowRight} size={'lg'} />
                </span>
              </div>
            )}
            {locationOrder?.Status?.status_id !== 15 && (
              <div
                className="order-status-block"
                style={{ backgroundColor: locationOrder?.Status?.status_color }}
              >
                {ORDER_STATUS_COMMENT[parseInt(locationOrder.Order.status_id)]}
                {/*Your order has been placed*/}
                <span className="float-right mr-1">
                  <FontAwesomeIcon icon={faArrowRight} size={'lg'} />
                </span>
              </div>
            )}
          </Link>
        </StyledUpdatedStatusBlock>
      );
    }
  }

  render() {
    const { orders } = this.props;
    const locations = _.keys(orders);
    if (locations && locations.length > 1)
      return this.renderMultipleLocationOrders(locations, orders);
    else if (locations && locations.length === 1)
      return this.renderSingleLocationOrder(locations, orders);
    return null;
  }
}

const StyledUpdatedStatusBlock = styled.div``;
function mapStateToProps(state) {
  const { orders, location, locationSettings, childLocations } = state;
  const outlets = childLocations ? childLocations.map((ot) => ot.loc_id) : null;
  let currentOrders = orders;
  if (outlets)
    currentOrders = _.filter(
      orders,
      (order) => outlets.indexOf(parseInt(order?.Order?.location_id)) !== -1
    );
  const groupedOrders = _.groupBy(currentOrders, (order) => order?.Order?.location_id);
  return { outlets: outlets, orders: groupedOrders, _location: location, locationSettings };
}

export default connect(mapStateToProps, { getOrders })(StatusBlock);
